/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Destination portal identifier.
 */
export enum PropertyPortal {
    MELI = 'meli',
    TOCTOC = 'toctoc',
    PROPPIT = 'proppit',
    YAPO = 'yapo',
}
